import { debounce } from '../../utils/lodash-replacements';
import { standardizeHeights } from '../../core/INF-gridAlignment';

export default () => {
  const thumbs = document.querySelectorAll('[data-article-tile-custom]');

  if (thumbs.length === 0) {
    return;
  }

  const gridItemSelector = '[data-article-tile-custom]';
  const childSelectors = [
    '[data-article-tile-custom-thumb]',
    '[data-article-tile-custom-article-link]',
    '[data-article-tile-custom-blog-link]',
    '[data-article-tile-custom-read-more]',
  ];

  const resizeHandler = debounce(() => {
    standardizeHeights(gridItemSelector, childSelectors);
  }, 500);

  window.addEventListener('resize', resizeHandler);
};
